<template>
  <q-card :flat="$q.screen.lt.md">
    <q-card-section class="text-center q-pa-xs" v-if="value">
      <span class="text-subtitle2">
        <q-chip color="indigo" text-color="white" :label="value.toLocaleString()" />
      </span>
      <q-icon
          v-if="items && items.length>1"
          :name="items[items.length - 1].ConversionRate > items[items.length - 2].ConversionRate?'arrow_upward':'south'"
          :color="items[items.length - 1].ConversionRate > items[items.length - 2].ConversionRate?'green':'red'"
          size="lg">
        <q-tooltip>
          نسبت به ماه گذشته
        </q-tooltip>
      </q-icon>
      <q-space/>
      <q-chip clickable color="brown" text-color="white" square label="میانگین فروش روزانه"/>
    </q-card-section>
    <q-tooltip content-class="bg-transparent text-black" v-if="items && items.length>0">
      <q-card flat bordered>
        <q-card-section>
          <LineChart :items="items" :data="this.items.map(item => item.ConversionRate)"
                     title="میانگین فروش"/>
        </q-card-section>
      </q-card>
    </q-tooltip>
  </q-card>
</template>

<script>
import LineChart from "@/components/OrderTrace/LineChart";

export default {
  name: "AverageSaleRateInMonth",
  components: {LineChart},
  props: {
    items: {
      type: Array,
      required: false,
      default: () => []
    },
    value: {
      type: Number,
      default: () => undefined
    }
  },
  data() {
    return {
      orderChartOptions: {
        chart: {
          id: 'ConversionRate',
          type: 'area',
          toolbar: {
            show: false
          }
        },
        title: {
          text: 'مقایسه نرخ تبدیل ماهیانه در سال جاری',
          align: 'center',
          floating: false,
          style: {
            fontFamily: 'IRANSans, sans-serif'
          }
        },
        xaxis: {
          labels: {
            hideOverlappingLabels: true,
            rotate: -45
          },
          categories: []
        },
      },
      orderChartSeries: [{
        name: 'مقدار',
        data: []
      }],
    }
  },
  created() {
  }
}
</script>

<style scoped>

</style>